module.exports = __webpack_public_path__ + "img/gallery-10.a4959d0a.jpg";